import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const wooCommerceIntegrationSchema = z.object({
  id: zExt.objectId(),
  enabled: z.boolean(),
  shopUrl: z.string(),
  consumerKeyPreview: z.string(),
  consumerSecretPreview: z.string(),
  ordersSyncAt: z.coerce.date().nullable(),
  ordersSyncIntervalSeconds: z.number(),
});

export const wooCommerceCredentialsInputSchema = z.object({
  shopUrl: z.string().min(1),
  consumerKey: z.string().min(1),
  consumerSecret: z.string().min(1),
});

export const wooCommerceSettingsInputSchema = z.object({
  enabled: z.boolean().optional(),
  shopUrl: z.string().min(1).optional(),
  consumerKey: z.string().optional(),
  consumerSecret: z.string().optional(),
  ordersSyncIntervalSeconds: z.number().int().min(60).max(86_400).optional(),
});
